<template lang="pug">
  footer.appFooter
    .appFooter__inner
      .appFooter__info
        .name #[strong.primary bbdo] &nbsp; ATLANTA
        a.hover-shift.address-wrapper(:href="contact.addressUrl" target="_blank")
          .address {{ contact.address }}
      .appFooter__links
        a.phone.hover-shift.no-break(:href="`tel:${contact.phone}`") {{contact.phone}}
        a.email.hover-shift.no-break(:href="`mailto:${contact.email}`") {{contact.email}}
        a.intranet.hover-shift.no-break(v-if="contact.intranet" :href="contact.intranet" target="_blank") Intranet
      .appFooter__social
        social-button(network="instagram" :to="contact.instagram")
        social-button(network="twitter" :to="contact.twitter")
        social-button(network="facebook" :to="contact.facebook")
        social-button(network="linkedin" :to="contact.linkedin")
</template>

<script>
import { mapState } from 'vuex'
import debug from 'debug'
import SocialButton from '@/components/SocialButton'

let log = debug('component:AppFooter')

export default {
  name: 'appFooter',
  mounted () {
    log('Mounted')
  },
  components: {
    SocialButton,
  },
  computed: mapState({
    contact: (state) => state.contact,
  }),
}
</script>

<style scoped lang="scss">
.appFooter {
  font-size: 14px;
  padding: 50px $desktopMargins;
  &__inner {
    position: relative;
    height: 100%;
    width: 100%;
    max-width: $grid-max-width;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
  }

  &__info,
  &__links,
  &__social {
    display: flex;
  }

  &__info {
    .name {
      padding-right: 40px;
      text-transform: uppercase;
      line-height: 2;
    }

    .address-wrapper {
      @media #{$mobile} {
        white-space: pre-line;
      }
    }
  }

  &__links {
    .email {
      margin: 0 35px;
    }
  }

  @media (max-width: 1200px) {
    &__info {
      flex-direction: column;
    }
  }

  @media #{$tablet} {
    &__links {
      flex-direction: column;
      text-align: center;
      .email {
        margin: 10px 0;
      }

      .hover-shift {
        margin: 3px auto;
      }
    }
  }

  @media #{$mobile} {
    height: auto;
    padding-top: 45px;
    padding-bottom: 45px;
    &__inner {
      flex-direction: column;
      align-items: flex-start;
    }
    &__links {
      text-align: left;
      margin: 20px 0;
    }

    .hover-shift {
      margin: 5px 5px 5px 0;
    }
  }
}
</style>
